import { Snackbar, Alert } from "@mui/material";
import { createContext, useCallback, useState } from "react";
import CONFIG from "./CONFIG";

export const SnackbarContext = createContext();

export const SnackbarProvider = ({ children }) => {
  const [snack, setSnack] = useState({
    message: "",
    open: false,
    type: "success",
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnack({ open: false, message: "" });
  };

  const openErrorSnack = useCallback((message) => {
    setSnack({ open: true, message, type: "error" });
  }, []);

  const openSuccessSnack = useCallback((message) => {
    setSnack({ open: true, message, type: "success" });
  }, []);

  // other possible types: warning, info

  return (
    <SnackbarContext.Provider value={{ openErrorSnack, openSuccessSnack }}>
      {children}
      <Snackbar
        open={snack.open}
        autoHideDuration={CONFIG.snackbarTimeout}
        onClose={handleClose}
      >
        <Alert
          elevation={6}
          variant="filled"
          onClose={handleClose}
          severity={snack.type}
        >
          {snack.message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};
